import copyTextButton from 'utils/buttons';
import Base from 'app/views/base';
import LoaderView from 'app/views/loader_view';

import ItemView from '../item';
import tmpl from './template';

export class Heading {
  constructor({
    property,
    display,
    displayView,
    xsSize,
    smSize,
    mdSize,
    xsHidden = false,
    smHidden = false,
    wrapperClass,
    onClick,
    text,
    subView,
  }) {
    this.property = property;
    this.display = display;
    this.displayView = displayView;
    this.xsSize = xsSize;
    this.smSize = smSize;
    this.mdSize = mdSize;
    this.xsHidden = xsHidden;
    this.smHidden = smHidden;
    this.wrapperClass = wrapperClass;
    this.onClick = onClick;
    this.text = text;
    this.subView = subView;
  }

  static computeHeadingDisplayId(idx) {
    return `display-heading-${idx}`;
  }

  computeClass(model) {
    const classes = [];

    if (this.xsHidden || this.smHidden) {
      classes.push('d-none');
      if (this.smHidden) {
        classes.push('d-md-flex');
      } else if (this.xsHidden) {
        classes.push('d-sm-flex');
      }
    } else {
      classes.push('d-flex');
    }

    if (this.xsSize) {
      classes.push(`col-${this.xsSize}`);
    }

    if (this.smSize) {
      classes.push(`col-sm-${this.smSize}`);
    }

    if (this.mdSize) {
      classes.push(`col-md-${this.mdSize}`);
    }


    if (this.wrapperClass) {
      if (typeof this.wrapperClass === 'function') {
        classes.push(this.wrapperClass(model));
      } else {
        classes.push(this.wrapperClass);
      }
    }

    return classes.join(' ');
  }
}

export const List = Base.extend({
  compiledTemplate: tmpl,

  events: {
    'click #get_next_page': 'getNextPage',
  },

  initialize({
    noResultsMessage = 'No items found.',
    headings = [],
    showDetails = false,
    subItems = false,
    columnClasses = 'col-12',
    wrapperClass = '',
  }) {
    this.noResultsMessage = noResultsMessage;
    this.headings = headings;
    this.uid = parseInt(Math.random() * 100000, 10);
    this.showDetails = showDetails;
    this.subItems = subItems;
    this.columnClasses = columnClasses;
    this.fetchError = undefined;
    this.wrapperClass = wrapperClass;

    this.listenTo(this.collection, 'request', () => { this.fetchError = undefined; });
    this.listenTo(this.collection, 'error', () => { this.fetchError = true; });
    this.listenTo(this.collection, 'sync error', this.render);

    this.addSubview('loader', '#loader', new LoaderView({ collection: this.collection, cssClass: 'my-4' }));

    // this check can be removed once all list pages use a PageableBase
    if (this.collection.getFirstPage) this.collection.getFirstPage();
  },

  beforeRender() {
    this.headings.forEach((heading, idx) => {
      const headingDisplayId = Heading.computeHeadingDisplayId(idx);
      if (heading.displayView && !this.getSubview(headingDisplayId)) {
        this.addSubview(
          headingDisplayId,
          `#${headingDisplayId}`,
          heading.displayView,
        );
      }
    });
    this.collection.each(model => {
      const subviewName = this.computeId(model.id || model.cid);

      if (!this.getSubview(subviewName)) {
        this.addSubview(
          subviewName,
          `#${subviewName}`,
          new ItemView({
            model,
            headings: this.headings,
            showDetails: this.showDetails,
            subItems: this.subItems,
          }),
        );
      }
    });
  },
  afterRender() {
    copyTextButton.call(this);
  },

  computeId(id) {
    return `${this.uid}-model-${id}`;
  },

  context() {
    return {
      computeHeadingDisplayId: Heading.computeHeadingDisplayId,
      headings: this.headings,
      firstFetchSuccess: this.collection.firstFetchSuccess,
      collection: this.collection.fullCollection || this.collection,
      computeId: this.computeId,
      uid: this.uid,
      noResultsMessage: this.noResultsMessage,
      hasNextPage: this.collection.hasNextPage ? this.collection.hasNextPage() : undefined,
      fetchError: this.fetchError,
      columnClasses: this.columnClasses,
      wrapperClass: this.wrapperClass,
    };
  },

  getNextPage() {
    // Only works with collections that are an instance of backbone.paginator
    this.collection.getNextPage();
  },
});



// WEBPACK FOOTER //
// ./app/components/list/list/index.js